import {Command} from './Command';
import {AddStairsAction} from '../actions/AddStairsAction';
import {DeleteObjectService} from '../../delete-object.service';
import {StageService} from '../../stage.service';

export class AddStairsCommand extends Command<AddStairsAction> {

  private superStructureId: number;

  constructor(
    private deleteObjectSrvc: DeleteObjectService,
    private stageSrvc: StageService
  ) {
    super();
  }

  do(action: AddStairsAction): void {
    this.superStructureId = action.superStructureId;
  }

  undo(): void {
    const stairs = this.stageSrvc.findObject(
      obj => obj.userData.config && obj.userData.config.superstructureId === this.superStructureId
    );
    this.deleteObjectSrvc.delete(stairs);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/commands/AddStairsCommand.ts